var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsErrorIcon = function SvgDsErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.666 6.667a.667.667 0 1 0-1.333 0v2.666a.667.667 0 0 0 1.333 0zM8.666 11.333a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.752 2.47c-.76-1.382-2.745-1.382-3.505 0L1.17 11.703c-.733 1.333.231 2.964 1.753 2.964h10.156c1.521 0 2.486-1.631 1.753-2.964zm-2.336.642a.667.667 0 0 1 1.168 0l5.078 9.233a.667.667 0 0 1-.584.988H2.922a.667.667 0 0 1-.585-.988z",
    clipRule: "evenodd"
  })));
};
export default SvgDsErrorIcon;